import Root from "containers/root";
import { initCrmTracking } from "helpers/tracking";
import moment from "moment";
import React from "react";
import { createRoot } from "react-dom/client";
import store from "./store";
import "moment/locale/ru";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { NotificationContainer } from "react-notifications";
import "react-datepicker/dist/react-datepicker.css";

moment.locale("ru");
window.ChatraGroupID = "xTvAJFAFKT2e7Tsrg";
initCrmTracking();

const BUGSNAG_ENVS = ["production", "test"];
const entry = document.getElementById("entry");

if (entry) {
    const root = createRoot(entry);
    if (process.env.NODE_ENV && BUGSNAG_ENVS.includes(process.env.NODE_ENV) && process.env.BUGSNAG_API_KEY) {
        const bugsnagClient = Bugsnag.start({
            apiKey: process.env.BUGSNAG_API_KEY,
            plugins: [new BugsnagPluginReact()],
            releaseStage: process.env.BUGSNAG_RELEASE_STAGE,
        });

        const ErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React);

        root.render(
            <ErrorBoundary>
                <Root store={store} bugsnagClient={bugsnagClient} />
                <NotificationContainer />
            </ErrorBoundary>,
        );
    } else {
        root.render(
            <>
                <Root store={store} />
                <NotificationContainer />
            </>,
        );
    }
}
